import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const CheerleadingColored = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg width={IconSizes[size]} height={IconSizes[size]} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g id="Cheerleading" fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="m10.641 2.237-8.89 14.896c-.443.444.377 1.762 1.799 3.184 1.422 1.422 2.924 1.92 3.367 1.476l14.97-8.508c.286-2.534-.91-5.003-3.587-7.405-2.677-2.401-5.23-3.616-7.659-3.643z"
                    fill="#BB45FF"
                />
                <path
                    d="M15.125 18.456c0 .16-.086.31-.225.392l-2.927 1.724a.457.457 0 0 1-.553-.07l-.11-.109 3.815-2.247v.31zM6.37 20.981c-.33-.107-1.09-.55-1.943-1.404-.854-.854-1.297-1.613-1.405-1.943L10.305 5.27c.857 1.73 2.396 3.57 3.628 4.802 1.514 1.515 3.135 2.762 4.564 3.511.085.045.159.073.24.114L6.372 20.981zm14.634-8.627c-.575.028-2.831-.869-5.658-3.696C12.52 5.832 11.613 3.621 11.65 3h.038c.669 0 2.85.926 5.62 3.697 2.827 2.826 3.734 5.038 3.697 5.658zm1.442 1.443c.557-.557.972-1.694-.213-3.95-.75-1.429-1.996-3.05-3.511-4.565-2.273-2.273-6.627-5.616-8.515-3.725-.062.062-8.913 15.071-8.913 15.071-.861 1.081.3 2.944 1.719 4.363 1.082 1.081 2.422 2.013 3.476 2.013.329 0 .63-.09.887-.295l2.154-1.268.475.475a2.454 2.454 0 0 0 2.982.38l2.928-1.725a2.464 2.464 0 0 0 1.209-2.115v-1.488s5.169-3.018 5.322-3.17z"
                    fill="#0D0E0F"
                />
            </g>
        </svg>
    );
};
